var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cw-order-list"},_vm._l((_vm.orders),function(order){return _c('cw-order-cell',{key:order._optimisticKey || order.workOrderId + order.tripType,attrs:{"boxSetInfo":order},on:{"click":function($event){return _vm.selectionHandler(order)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }